import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const ContainerDiv = styled.div`
  height: 40px;
  margin-bottom: 12px;
  display: flex;
  width: 100%;
`

const ColourDiv = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 26px;
`

const TextDiv = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

interface IProps {
  colour: string
}

const Legend = (props: PropsWithChildren<IProps>) => (
  <ContainerDiv>
    <ColourDiv style={{ background: props.colour }} />
    <TextDiv>{props.children}</TextDiv>
  </ContainerDiv>
)

export default Legend
